import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import {
  Navigation,
  NavItem,
  Page,
  PromiseContainer,
  QueryContainer,
} from '../../../components';
import { useIsAdmin, useStore } from '../../../store';
import usePromise from '../../../store/utils/usePromise';
import Columns from './components/Columns';
import Filters from './components/Filters';
import KeysGrid from './components/KeysGrid';

export default observer(function PulseKeysPage() {
  const { pulseKeyStore } = useStore();
  const isAdmin = useIsAdmin();
  const [searchPromise] = usePromise(() => pulseKeyStore.createKeySearch());

  function createNavigation(): Navigation {
    const fileExport: NavItem = {
      button: { type: 'primary', sx: { mr: 1 } },
      icon: 'file-export',
      right: true,
      route: '/pulse-keys/export',
      title: 'Export',
    };

    if (searchPromise.state === 'fulfilled') {
      const search = searchPromise.value;

      const params: Record<string, string> = {
        sellableId: search.filters.sellableId,
        status: search.filters.status,
        label: search.filters.label,
      };

      Object.keys(params).forEach((key) => {
        if (!params[key]) {
          delete params[key];
        }
      });

      const searchParams = new URLSearchParams(params).toString();
      fileExport.route += `?${searchParams.toString()}`;
    }

    return [
      {
        button: { type: 'primary', sx: { mr: 1 } },
        icon: 'people-arrows',
        right: true,
        route: '/pulse-keys/move-customer-keys',
        title: 'Move customer keys',
        visible: isAdmin,
      },
      fileExport,
      {
        button: { type: 'primary' },
        icon: 'tag',
        right: true,
        route: '/pulse-keys/labels',
        title: 'Manage labels',
      },
    ];
  }

  return (
    <Page navigation={createNavigation()}>
      <PromiseContainer promise={searchPromise}>
        {(search) => (
          <Grid container>
            <Grid item lg={3} xs={12}>
              <Filters search={search} />
              <Columns search={search} />
            </Grid>
            <Grid item lg={9} xs={12}>
              <QueryContainer empty={false} query={search.query}>
                {(pulseKeys) => (
                  <KeysGrid pulseKeys={pulseKeys} search={search} />
                )}
              </QueryContainer>
            </Grid>
          </Grid>
        )}
      </PromiseContainer>
    </Page>
  );
});
